import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config.service';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { MandateAssessmentStatus } from '../interfaces/mandate-assessment-status';
import { catchError, Observable } from 'rxjs';
import { handleError } from 'src/app/shared/functions/error-handler';

@Injectable({
  providedIn: 'root',
})
export class CaseloadService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public fetchMandatesAssessments(
    type: string
  ): Observable<MandateAssessmentStatus[]> {
    return this.http
      .get<MandateAssessmentStatus[]>(`${this.config.apiUrl}/${type}`)
      .pipe(catchError(handleError));
  }
}
